/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown>, message: NonNullable<unknown> }} Spaces_Wizard_Validation_ErrorInputs */



/**
* | output |
* | --- |
* | "Form validation failed: {field} — {message}" |
*
* @param {Spaces_Wizard_Validation_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_validation_error = /** @type {((inputs: Spaces_Wizard_Validation_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Validation_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Formularprüfung fehlgeschlagen: ${i?.field} — ${i?.message}`)
	return /** @type {LocalizedString} */ (`Form validation failed: ${i?.field} — ${i?.message}`)
});